<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T20:46:35+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T20:06:33+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-card>
        <b-tabs>
            <b-tab active>
                <template v-slot:title>
                    <span class="">View SOP</span>
                </template>
                <!--<b-row>
                    <b-col cols="12">
                        <b-card>
                            <div class="card-title" style="display: inline-flex;">
                                <span class="ms-2 pt-1">View Document</span>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>-->
                <b-row >
                    <b-col xl="8" cols="12">
                        <div class="card bg-dark pdfCard">
                            <annotate-pdf
                            class="border border-success"
                            v-if="b64 != null && show_document"
                            :signature_svg="client_signatures"
                            :sign_mode="signMode"
                            @progress="setProgress"
                            @saveSignedPDF="handleSignatureJob"
                            :base64="b64"/>
                            <!--<div v-if="b64 != null && show_document">
                                <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
                            </div>-->
                            <b-alert v-else show>{{message}}</b-alert>

                        </div>
                    </b-col>

                    <b-col xl="4" cols="12">
                        <!-- <b-card class="border border-dark">
                            <b-button size="lg" @click="$bvModal.show('notesModal');" variant="outline-success">
                                <i class="fas fa-comment"></i>
                            </b-button>
                            &nbsp;
                            <b-button size="lg" variant="outline-success">
                                <i class="fas fa-envelope"></i>
                            </b-button>
                        </b-card> -->

                        <b-card class="border border-dark" title="SOP Info">
                            <div v-if="sop_data != null">
                                <p>
                                    <strong>SOP Code:</strong>&nbsp;
                                    {{ sop_data.sop_code }}
                                </p>
                                <p>
                                    <strong>SOP Group:</strong>&nbsp;
                                    {{ sop_data.client_s_o_p_group.name }}
                                </p>
                                <p>
                                    <strong>SOP Name:</strong>&nbsp;
                                    {{ sop_data.name }}
                                </p>
                                <p v-if="revision_data != null">
                                    <strong>Revision No:</strong>&nbsp;
                                    {{ revision_data.client_revision_no }}
                                </p>
                                <p v-if="revision_data != null">
                                    <strong>Date Released:</strong>&nbsp;
                                    {{ revision_data.effective_date }}
                                </p>
                            </div>
                        </b-card>
                        <!-- ************ -->
                        <!-- <b-card class="border border-dark" title="Notes">

                        </b-card> -->
                        <!-- ************ -->
                        <!-- <b-card class="border border-dark" v-if="is_actionable_view">
                            <b-row>
                                <b-col cols="12">
                                    <b-button :disabled="scroll_progress > 90 ? false : true" variant="primary" size="lg" @click="readDoc" >
                                        Read</b-button>
                                    &nbsp;
                                    <b-button variant="danger" size="lg" @click="flagDoc">
                                        Flag</b-button>
                                </b-col>
                            </b-row>
                        </b-card> -->
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab v-if="false">
                <template v-slot:title>
                    <span class="">SOP Actions</span>
                </template>
                <DocumentActions/>
            </b-tab>
        </b-tabs>
        <uploader v-show="false" :options="uploadOptions" :autoStart="false" :ref="'sign_upload'" class="uploader-example">
            <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                    <p>Drop file here to upload or</p>
                    <uploader-btn type="button" :single="false"><i class="fas fa-file fa-fw"></i> Select file</uploader-btn>&nbsp;
                </uploader-drop>
            <uploader-list></uploader-list>
        </uploader>
        <b-modal hide-footer title="Comment" id="notesModal">
            <div class="modal-body">
                <b-form>
                    <b-form-group class="mb-4" label="Comment: " label-for="comment" label-cols-sm="3">
                        <b-form-input
                            id="comment"
                            type="text"
                            v-model="new_comment_text"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary">Save</button>
                <button type="button" class="btn btn-secondary">Close</button>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import pdfMixin from '@/mixins/pdfMixin.js'
import Swal from 'sweetalert2'
import _ from 'lodash';
import DocumentActions from './viewDocumentActions.vue'
import { sopClientAdminState, sopClientAdminMethods, layoutMethods, userMethods, userState} from '@/state/helpers.js'
export default {
    mixins: [ pdfMixin ],
    data:() => ({
        b64: null,
        message: 'Waiting for document data',
        show_document: null,
        revision_data: null,
        scroll_progress: 0,
        document_load_error: false,
        new_comment_text: '',
    }),
    components:{
        DocumentActions,
    },
    props:{
        //* show the 'Read' and 'Flag' buttons if true
        is_actionable_view:{
            default: false
        },
        view_id:{
            default: null,
        }
    },
    computed:{
        ...userState,
        ...sopClientAdminState,
        uploadOptions() {
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem('x_token');
            var url = process.env.VUE_APP_API_BASEURL + 'api/clientdocadmin/uploadsignedsop';
            var options = {
                target: url,
                query: {
                    client_revision_id: "",
                    job_id: ""
                },
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                testChunks: false,
                withCredentials: true,
                fileParameterName: 'signed_sop', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            }
            return options;
        },
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
        signMode() {
            if (Object.keys(this.active_job_data).length > 0) {
                if (this.active_job_data.sign_mode) {
                    return true;
                }
            }
            return false;
        },
        client_signatures(){
            let signatures = {
                signature: null,
                initial: null,

            }
            if(this.client_signature != null){
                signatures.signature = this.client_signature.signature_svg;
            }
            if(this.client_initial != null){
                signatures.initial = this.client_initial.signature_svg;
            }
            console.table(signatures);
            return signatures;
        }
    },
    methods:{
        ...userMethods,
        ...layoutMethods,
        ...sopClientAdminMethods,
        findPublishedRevision(revision_id){
            if(revision_id != undefined){
                //* load passed in revision
                this.b64 = null;
                window.axios({
                    url: 'api/clientdocadmin/b64preview/' + revision_id,
                    method: 'GET',
                    responseType: 'blob',
                })
                .then( async (response) => {
                    const response_data = response.data;
                    let index = _.findIndex(this.sop_revisions, function(o) { return o.client_revision_id == revision_id; });
                    this.revision_data = _.cloneDeep(this.sop_revisions[index]);
                    //* process the pdf using the helper method from pdfMixin.js
                    this.b64 = await this.processPdfBlob(response_data);
                    this.show_document = true;
                }).catch(() => {
                    this.show_document = false;
                    this.message = "There is not currently a published SOP revision!";
                });
            } else {
                let index = _.findIndex(this.sop_revisions, function(o) { return o.active == 1 || o.published == 1; });
                if (index > -1) {
                    this.selectRevision(index);
                }
                if (index == -1) {
                    this.show_document = false;
                    this.message = "There is not currently an active SOP revision!";
                }
            }
        },
        findPublishedRevisionForID(id){
            console.log('ID ',id);
            this.findPublishedRevision();
        },
        selectRevision(index){
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            //Load pdf b64 of latest revision
            this.b64 = null;
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + this.revision_data.client_revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then( async (response) => {
                //this.b64 = window.URL.createObjectURL(response.data);
                this.b64 = await new Response(response.data).arrayBuffer();
                this.show_document = true;
            }).catch(() => {
                this.show_document = false;
                this.message = "There is not currently a published SOP revision!";
            });
        },
        handleSignatureJob(blob) {
            const el = this;
            const signedFile = new File([blob], 'sop.pdf', {
                type: blob.type,
            });
            const uploaderInstance = this.$refs['sign_upload'];
            const upload = uploaderInstance.uploader;
            upload.addFile(signedFile);
            upload.opts.query.client_revision_id = this.active_job_data.revision_id;
            upload.opts.query.job_id = this.active_job_data.job_id;
            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on('fileSuccess', (rootFile, file, message, chunk)=>{
                var response = JSON.parse(message);
                if(response.success){
                    Swal.fire("Uploaded", "SOP Approved!", "success");
                    upload.off("fileSuccess");
                    upload.cancel();
                    el.setActiveJobInfo({});
                    el.loadNotifications();
                    document.getElementById('view-close-button').click();
                }
                else {
                   //eslint-disable-next-line no-console
                    console.log("Upload error");
                }
            });
        },
        setProgress(progress){
            if(progress > this.scroll_progress){
                this.scroll_progress = progress;
            }
        },
        flagDoc(){
            let params = {
                "actionable_id":"1",
                "complete":false,
                "flagged":true,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'red',
                    icon: 'error',
                    title:'Flagged document.',
                    customClass: {     popup: 'warning-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
            })
        },
        readDoc(){
            let params = {
                "actionable_id":"1",
                "complete":true,
                "flagged":false,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Marked as read.',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });

            })
        },
        showSignMenu(){
            this.updateMenuType({
                type: 'null',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        this.showSignMenu();
        if(this.is_actionable_view == true){
            this.findPublishedRevision(this.active_job_data.revision_id);
            //this.findPublishedRevisionForID(this.view_id);
        }
        else{
            this.findPublishedRevision();
        }

        if(this.client_signature == null){
            this.loadClientSignature('signature');
        }
        if(this.client_initial == null){
            this.loadClientSignature('initial');
        }
    },
    beforeDestroy() {
        if(this.signMode) {
            //clear job data ? 
            this.setActiveJobInfo({});
        }
    }
}
</script>

<style>

</style>
